import { useTheme } from "@emotion/react";
import {
  Grid,
  Box,
  Stack,
  Typography,
  Button,
  useMediaQuery,
  Divider,
} from "@mui/material";
import { Link } from "react-router-dom";

const Intro = () => {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <Box maxWidth={1000} m="auto" width={"90%"} pt={16} pb={8}>
      <Grid
        container
        columns={{ xs: 5, md: 12 }}
        spacing={8}
        mt={{ md: 0 }}
        alignItems="center"
      >
        <Grid item xs={7}>
          <Stack spacing={2} alignItems="start">
            <Typography
              variant="body1"
              textTransform="uppercase"
              fontWeight={500}
              color="accent.main"
            >
              Franchisee
            </Typography>
            <Typography variant={sm ? "h2" : "h3"}>
              Own a Protein Box Franchise
            </Typography>
            <Typography
              variant={sm ? "body1" : "body2"}
              color="text.secondary"
              pb={2}
            >
              Build your own Protein Box outlet and be part of the fast-growing
              healthy food movement.
            </Typography>
            <a href="/franchisee#form" style={{ textDecoration: "none" }}>
              <Button variant="contained">Apply now</Button>
            </a>
            <Stack direction="row" spacing={4} pt={4}>
              <Stack spacing={0.5}>
                <Typography variant="h6">100,000+</Typography>
                <Typography variant="body2" color="text.secondary">
                  meals sold
                </Typography>
              </Stack>
              <Divider flexItem orientation="vertical" />
              <Stack spacing={0.5}>
                <Typography variant="h6">4.5/5</Typography>
                <Typography variant="body2" color="text.secondary">
                  Average rating
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={5}>
          <img
            src="/images/utpal-shake.jpeg"
            style={{ borderRadius: 16 }}
            width="100%"
            alt=""
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Intro;
